import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { UploaddocumentClientResponse } from '../@types/UploadDocument'

type Store = {
  uploadDocument: UploaddocumentClientResponse | null
  setUploadDocument: (value: UploaddocumentClientResponse) => void
}

export const useUploadDocumentStore = create<Store>()(
  devtools(
    (set) => ({
      uploadDocument: null,
      setUploadDocument: (uploadDocument) => set({ uploadDocument }),
    }),
    { name: 'UploadDocumentStore' },
  ),
)
